import { sampleClips } from "./sampleData.js";
export function getWeddingSample(staticAssetBaseUrls, themeId = "wedding-guest-book", themeVersion) {
    return {
        version: 1,
        occasionId: "wedding",
        themeId,
        themeVersion,
        staticAssetBaseUrls,
        videoFrame: {
            width: 1920,
            height: 1080,
            fps: 30,
        },
        introGreeting: {
            enabled: true,
            messages: [
                "Congratulations on your wedding, Amy & Dave ❤️",
                "May you find happiness and joy in your journey.",
                "Here's some well wishes from your loved ones.",
            ],
        },
        outroGreeting: {
            enabled: true,
            messages: ["Thank you for sharing your special day with us. ❤️"],
        },
        faceCollageEnabled: true,
        userInput: {
            name: "Jessica & David",
            date: "2024-06-14T07:00:00.000Z",
            subheading: "Our Wedding Day",
        },
        music: {
            enabled: true,
            volumeDuringClips: "low",
            song: {
                id: "a-minor-waltz",
                name: "A Minor Waltz",
                duration: 140.329796,
                urls: [
                    "https://memento-sandbox-music.s3.us-east-2.amazonaws.com/A_Minor_Waltz.mp3",
                ],
            },
        },
        logo: {
            enabled: false,
            size: "medium",
            urls: [],
        },
        branding: {
            enabled: true,
        },
        clips: sampleClips,
    };
}
